import { Slice } from 'hubspot-prosemirror/pm/model';
import { Plugin } from 'hubspot-prosemirror/pm/state';
import { isUrlAndNotEmail, linkify, linkifyTextNode } from './linkify';
import { ensureUrlHasProtocol } from '../../../draft-transplant/utils/libUtils';
function shouldTryToLinkify(nodeBefore, event) {
  const isAlreadyLink = nodeBefore.marks.some(mark => mark.type.name === 'link');
  return !isAlreadyLink && (event.key === ' ' || event.key.toLowerCase() === 'spacebar' || event.key.toLowerCase() === 'enter' || event.key === '\n');
}
export function createAutoDetectLinkPlugin(options = {}) {
  const autoDetectBareUrls = Boolean(options.autoDetectBareUrls);
  return new Plugin({
    props: {
      transformPasted: slice => {
        const result = linkify(slice.content, options);
        return new Slice(result, slice.openStart, slice.openEnd);
      },
      handlePaste: (view, event, __slice) => {
        var _event$clipboardData;
        const pastedText = (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text/plain');
        if (pastedText && isUrlAndNotEmail(pastedText, options) && !view.state.selection.empty) {
          const href = autoDetectBareUrls ? ensureUrlHasProtocol(pastedText) : pastedText;
          const tr = view.state.tr.addMark(view.state.selection.from, view.state.selection.to, view.state.schema.marks.link.create({
            href
          }));
          view.dispatch(tr);
          return true;
        }
        return false;
      },
      handleKeyDown(view, event) {
        const {
          state,
          dispatch
        } = view;
        const {
          $from
        } = state.selection;
        const {
          nodeBefore
        } = $from;

        // Detect a ' ' or spacebar or Enter key press
        if (nodeBefore != null && shouldTryToLinkify(nodeBefore, event)) {
          const linkifiedTextNode = linkifyTextNode(nodeBefore, options);
          const didLinkify = linkifiedTextNode.length > 0 && linkifiedTextNode.some(node => node.marks.some(mark => mark.type.name === 'link'));
          if (didLinkify) {
            const textLength = nodeBefore.text == null ? 0 : nodeBefore.text.length;
            const replaceFrom = $from.pos - textLength;
            const replaceTo = $from.pos;
            const tr = state.tr.replaceWith(replaceFrom, replaceTo, linkifiedTextNode);
            dispatch(tr);
          }
        }
        return false; // Allow default handling for other keys
      }
    }
  });
}
export const AutoDetectLinkPlugin = createAutoDetectLinkPlugin();